import React, { useState, useEffect } from 'react';
import CommonMessage from "../components/CommonMessage";
import { web3AccountCheck, contractCall } from '../helper/web3helper';
import hostContract from '../web3/hostContract.json';
import web3Config from '../web3/web3Config.json';
import { formatEmailDetails, formatMessageList, getWeb2emails } from '../helper/dataFormatHelper';
import Cookies from "universal-cookie";
import { useSelector, useDispatch } from 'react-redux';
import { useWalletReconnectionWithLoader } from '../helper/useWalletReconnection';
import { getEmails, getSentEmails } from '../helper/emailHelper';
import { reportError, toErrorString } from '../utils/errorLogger';
const cookies = new Cookies();

const Trash = () => {
  const [user] = useState(cookies.get("userObject"));
  const [web3Value, setWeb3] = useState(null);
  const [account, setAccount] = useState('');
  const [web3Contract, setWeb3Contract] = useState('');
  const [allBoxList, setAllBoxList] = useState([]);
  const [readList, setReadList] = useState([]);
  const [unreadList, setUnreadList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [rendered, setRendered] = useState(false);
  const dispatch = useDispatch();
  const [text, setText] = useState("")

  useEffect(() => {
    web3AccountCheck(setWeb3, setAccount);
    setWeb3Contract(contractCall(hostContract.contract, web3Config.CONTRACT));
    if (web3Contract) {
      setEmail();
    }
  }, []);

  useWalletReconnectionWithLoader(
    setLoader,
    setText,
    web3AccountCheck,
    setWeb3,
    setAccount,
    () => setEmail(),
    web3Contract
  );

  // useEffect(() => {
  //   if (account && web3Value) {
  //     const contractInstance = new web3Value.eth.Contract(hostContract.contract, web3Config.CONTRACT);
  //     setWeb3Contract(contractInstance);
  //   }
  // }, [web3Value, account]);

  const getRefreshMessage = useSelector((state) => state.refreshMessage)
  useEffect(() => {
    if (web3Contract) { setEmail(); }
  }, [web3Contract, getRefreshMessage]);

  const refreshCount = useSelector((state) => state.refreshCount);
  const reRender = () => {
    dispatch({ type: "REFRESH_COUNT", payload: !refreshCount });
    setEmail();
  }


  async function setEmail(loaderRequired = true) {
    // Tracks whether WE turned the loader on, so the finally below only ever clears a loader this call
    // raised — the early `return` when web3Contract isn't ready yet must leave the initial loader alone.
    let loaderShown = false;

    try {
      if (!web3Contract) return;

      if (loaderRequired) {
        setLoader(true);
        setText("Please wait, data is loading from the blockchain, Going forward it will be fast.")
        setRendered(false);
        loaderShown = true;
      }

      const emailList = await getEmails(user.name);
      const sentEmailList = await getSentEmails(user.name);
      const sentlist = await formatMessageList(sentEmailList.reverse(), "Senttrash");
      const updatedEmailList = await formatEmailDetails(emailList);

      const formattedResult = updatedEmailList
        .filter(email => email.senderName)
        .map(email => ({
          mailtype: "web3emails",
          id: parseInt(email.id),
          subject: email.subject,
          encryptedData: email.encryptedData,
          created_at: email.receivedDate,
          isStarred: email.isStarred,
          sender: email.senderName,
          isRead: email.isRead,
          header: email.emailDetails,
          isCC: email.isCC,
          isBCC: email.isBCC,
          ...email
        })).filter(data => !data.isSaved && data.isDeleted);
      const list = await formatMessageList(formattedResult.reverse(), "Trash");
      const web3 = list.allList;
      const allList = list.deletedList.concat(sentlist.deletedList)
      const web3list = web3.concat(allList).sort((a, b) => new Date(b.date) - new Date(a.date));
      const formattedresponse = await getWeb2emails(user.name, "Trash");
      const web2deletedemails = formattedresponse.filter((data) => {
        const isTrashFolder = data.folder && data.folder.toLowerCase().includes('trash');
        if ((data.delete === 1 || isTrashFolder) && data.delete !== 3) {
          return data
        }
        return null;
      })
      const sortEmails = (web3list, web2deletedemails) => {
        const combined = [...web3list, ...web2deletedemails];
        const sortedCombined = combined.sort((a, b) => {
          const dateA = new Date(a.date || a.receivedDate);
          const dateB = new Date(b.date || b.receivedDate);
          return dateB - dateA;
        });
        return sortedCombined;
      };
      const sortedresponse = sortEmails(web3list, web2deletedemails);
      setAllBoxList(sortedresponse);
      const readList = sortedresponse.filter(message => message.isRead);
      const unReadList = sortedresponse.filter(message => !message.isRead);
      setReadList(readList);
      setUnreadList(unReadList);
      if (loaderRequired) {
        setRendered(true);
      }

    } catch (error) {
      const userName = localStorage.getItem('UserName');
      const errorStr = toErrorString(error || error.message);
      reportError({
        endpoint: '-',
        message: `FileName: Trash.js, Fun: setEmail, ${String(error.message || 'Unhandled error')}`,
        error: errorStr,
        userName: userName || '',
      });
      console.log("error", error);
    } finally {
      // The catch above only logged: any throw left the spinner up for good. Clearing here covers both the
      // success and the failure path (setRendered is idempotent).
      if (loaderShown) {
        setRendered(true);
        setLoader(false);
        setText("");
      }
    }
  }

  useEffect(() => {
    if (rendered) {
      setLoader(false)
      setText("")
    }
  }, [rendered]);


  return (
    <div className="inbox-container">
      <CommonMessage messageList={allBoxList} pageType={"Trash"} unreadList={unreadList} readList={readList} loader={loader} reRender={reRender} text={text} />
    </div>
  );
}

export default Trash
